import { Typography } from '@mui/material'
import React from 'react'
import { RouteImage } from '../../assets/routeImage';

type Props = {
    text: string;
    align: 'start' | 'center' | 'end',
    minWidth?: string;
    className?:string;
}

const HeaderTopicTable: React.FC<Props> = (props: Props) => {
    return (
        <span
            style={{ minWidth: props.minWidth ? props.minWidth : '150px' }}
            className={`flex justify-${props.align ? props.align : 'start'} ${props.className} items-center gap-1`}>
            <Typography variant='h6'>
                {props.text}
            </Typography>
            <span>
                <img src={RouteImage.arrowTopBottom} alt="icon" />
            </span>
        </span>
    )
}

export default HeaderTopicTable